export default __webpack_public_path__ + "static/media/czech-republic.6d9eed92.svg";